import { VHeaders } from '@/models/pagedlistmodel';

export function getVendorTypeHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      text: vm.$parent.$t(
        'vendorTypeAccount.vendorTypeAccountGridHeader.name'
      ) as string,
      value: 'name',
    },
    {
      align: 'left',
      text: vm.$parent.$t(
        'vendorTypeAccount.vendorTypeAccountGridHeader.vendorType'
      ) as string,
      value: 'vendorTypeNumber',
    },
    {
      align: 'left',
      text: vm.$parent.$t(
        'vendorTypeAccount.vendorTypeAccountGridHeader.accountNumber'
      ) as string,
      value: 'accountNumber',
    },
    {
      align: 'center',
      isNotDataProp: true,
      text: vm.$parent.$t(
        'vendorTypeAccount.vendorTypeAccountGridHeader.action'
      ) as string,
      sortable: false,
    },
  ];
}
